import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {AppState} from '../../index';
import {NotificationService} from '../../../../services/notification.service';
import {
  actionProjectCategory,
  getAllProjectCategories,
  loadProjectCategories,
  upsertProjectCategory
} from './project-category.actions';
import {map, switchMap} from 'rxjs/operators';
import {Apollo} from 'apollo-angular';
import {GET_PROJECT_CATEGORY, SAVE_PROJECT_CATEGORY} from './project-category.graphql';
import {ActionTypeEnum} from '../../../../shared/enums/data.enums';
import {SettingsService} from '../../../../services/settings.service';

@Injectable()
export class ProjectCategoryEffects {

  get = createEffect(() => this.actions$.pipe(
    ofType(getAllProjectCategories),
    switchMap(() => {
      return this.apollo.query({
        query: GET_PROJECT_CATEGORY
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];

          if (result !== null && result?.response?.code === 9000) {
            this.store.dispatch(loadProjectCategories({ProjectCategories: result?.data}));
          }
        })
      );
    })
  ), { dispatch: false });

  save = createEffect(() => this.actions$.pipe(
    ofType(actionProjectCategory),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: SAVE_PROJECT_CATEGORY,
        variables: { inputDto: action.projectCategoryDto }
      }).pipe(
        map(({ data }: any) => {
          const result: any = Object.values(data)[0];

          if (result !== null && result?.response?.code === 9000){
            this.notificationService.successMessageAndCloseModals(result?.response?.message);
            if (action.projectCategoryDto.actionType === ActionTypeEnum.delete){
              this.settingsService.reloadCurrentRoute(null);
            }
            this.store.dispatch(upsertProjectCategory({projectCategory: result?.data}));
          }else {
            this.notificationService.errorMessage(result?.response?.message);
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private apollo: Apollo,
    private notificationService: NotificationService,
    private settingsService: SettingsService
  ) {
  }
}
